import React, { FC } from 'react';
import { Field, Form } from 'react-final-form';
import {
  CheckboxWrapper,
  TextInputWrapper,
  RadiobuttonWrapper,
  SelectInputWrapper,
  SelectWithTagsWrapper,
  RadioCardWrapper,
  SelectWithTagsWrapperNew,
  SelectWithEventsFieldsWrapper,
  SelectWithRolesFieldsWrapper,
} from 'components/forms';
import { Button } from 'components/ui';

const formFieldKeys = {
  text: 'text',
  textRequired: 'textRequired',
  radio: 'radio',
  checkbox: 'checkbox',
  select: 'select',
  selectWithTags: 'selectWithTags',
  selectWithTagsNew: 'selectWithTagsNew',
  radioCards: 'radioCards',
  selectEvents: 'selectEvents',
  selectRoles: 'selectRoles',
};

const UIComponents: FC = () => {
  const handleSubmit = (formValues: any): void => console.log({ formValues });

  return (
    <div className='container'>
      <h2 className='my-4'>Forms</h2>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Field
              className='mb-2'
              label='Field Label'
              name={formFieldKeys.text}
              component={TextInputWrapper}
            />
            <Field
              className='mb-2'
              label='Field Label'
              name={formFieldKeys.textRequired}
              component={TextInputWrapper}
              required
            />
            <Field
              className='mb-2'
              label='Field Label'
              name={formFieldKeys.checkbox}
              component={CheckboxWrapper}
              type='checkbox'
            />
            <Field
              className='mb-2'
              label='Field Label'
              value='first'
              name={formFieldKeys.radio}
              component={RadiobuttonWrapper}
              type='radio'
            />
            <Field
              className='mb-2'
              label='Field Label'
              value='second'
              name={formFieldKeys.radio}
              component={RadiobuttonWrapper}
              type='radio'
            />
            <Field
              className='mb-2'
              label='Field Label'
              value='third'
              name={formFieldKeys.radio}
              component={RadiobuttonWrapper}
              type='radio'
            />
            <Field
              className='mb-2'
              name={formFieldKeys.select}
              component={SelectInputWrapper}
              placeholder='Choose...'
              options={[
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' },
              ]}
            />
            <Field
              className='mb-2'
              name={formFieldKeys.selectWithTags}
              component={SelectWithTagsWrapper}
              label='Label'
              placeholder='Choose tag...'
              options={[
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' },
                { value: 'tea', label: 'Tea' },
              ]}
            />
            <Field
              className='mb-2'
              name={formFieldKeys.selectWithTagsNew}
              component={SelectWithTagsWrapperNew}
              placeholder='Choose tag...'
              options={[
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' },
                { value: 'tea', label: 'Tea' },
              ]}
            />
            <Field
              className='mb-2'
              label='Select with fields'
              name={formFieldKeys.selectEvents}
              component={SelectWithEventsFieldsWrapper}
            />
            <Field
              className='mb-2'
              label='Select with fields'
              name={formFieldKeys.selectRoles}
              component={SelectWithRolesFieldsWrapper}
            />
            <h3 className='mb-2'>Radiobuttons cards</h3>
            <div style={{ display: 'flex' }}>
              <Field
                className='m-2'
                label='Field Label'
                value='left'
                description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                name={formFieldKeys.radioCards}
                component={RadioCardWrapper}
                type='radio'
              />
              <Field
                className='m-2'
                label='Field Label'
                value='right'
                description='Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                name={formFieldKeys.radioCards}
                component={RadioCardWrapper}
                type='radio'
              />
            </div>
            <pre>{JSON.stringify(values, undefined, 2)}</pre>
          </form>
        )}
      />
      <h2 className='mb-2'>Buttons</h2>
      <h3 className='mb-2'>Primary</h3>
      <Button className='mb-2' color='red'>
        Button label
      </Button>
      <Button className='mb-2' color='dark'>
        Button label
      </Button>
      <Button className='mb-2' color='blue'>
        Button label
      </Button>
      <h3>Ghost</h3>
      <Button className='mb-2' variant='ghost' color='red'>
        Button label
      </Button>
      <Button className='mb-2' variant='ghost' color='dark'>
        Button label
      </Button>
      <Button className='mb-2' variant='ghost' color='blue'>
        Button label
      </Button>
      <h3 className='mb-2'>Secondary</h3>
      <Button className='mb-2' variant='secondary'>
        Button label
      </Button>
      <Button className='mb-2' variant='secondary' bold>
        Button label
      </Button>
      <Button className='mb-2' disabled>
        Button label
      </Button>
    </div>
  );
};

export default UIComponents;
